import { reducerWithInitialState } from "typescript-fsa-reducers"
import { couponCodeAction } from "../actions/CouponCodeAction"

export interface CouponCodeState {
  couponCode: string
}

const initialState: CouponCodeState = {
  couponCode: ""
}
// Reduxを利用した画面間共通のクーポンコードstate初期化処理
export const couponCodeReducer = reducerWithInitialState(initialState)
  .case(couponCodeAction.updateCouponCode, (state, couponCode) => {
    return { ...state, couponCode }
  })
  .default((state) => {
    return state
  })
